import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Cache-Control': 'public, max-age=3600',
    'Pragma': 'no-cache',
    'X-Requested-With': 'XMLHttpRequest',
    'Accept-Language': 'ko-KR,ko;q=0.9,en-US;q=0.8,en;q=0.7',
    'X-Client-Type': 'service',
  },
});

api.interceptors.request.use(
  config => {
    console.log('Request URL:', config.baseURL + config.url);
    console.log('Request Headers:', config.headers);
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  response => {
    console.log('Response:', response);
    return response;
  },
  error => {
    console.log('Error:', error);
    return Promise.reject(error);
  }
);

export const artist = {
  getArtist: () => api.get('/artist'),
  getArtistDetail: (id) => api.get(`/artist/${id}`),
}

export const press = {
  getPress: (page) => api.get('/press', { params: { page } }),
  getPressDetail: (id) => api.get(`/press/${id}`),
}
